export * from '@primeuix/themes/nora/progressbar';
export { default } from '@primeuix/themes/nora/progressbar';
